import { isFeatureEnabled } from '@lumapps/features';

import { FEATURE_FLAG_SEARCH_IN_SPACE_DEVELOPMENT, FEATURE_FLAG_SEARCH_IN_SPACE_EARLY_ACCESS } from './constants';

export const isSearchInSpaceInDevelopmentSelector = isFeatureEnabled(FEATURE_FLAG_SEARCH_IN_SPACE_DEVELOPMENT);
export const isSearchInSpaceEarlyAccessSelector = isFeatureEnabled(FEATURE_FLAG_SEARCH_IN_SPACE_EARLY_ACCESS);
